import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { FadeLoader } from "react-spinners";
import successImage from "../assets/success.png";
import errorImage from "../assets/error.png";
import api from "../api/api";

const stripePromise = loadStripe("pk_test_51Oml5cGAwoXiNtjJgPPyQngDj9WTjawya4zCsqTn3LPFhl4VvLZZJIh9fW9wqVweFYC5f0YEb9zjUqRpXbkEKT7T00eU1xQvjp");

const ConfirmOrder = () => {
  const isDev = process.env.NODE_ENV === "development";
  const devLog = (...args) => {
    if (isDev) console.log(...args);
  };
  const location = useLocation();
  const { paymentMethod, orderId: locationOrderId } = location.state || {};
  const orderId = locationOrderId || localStorage.getItem("orderId");

  // Estados para Stripe
  const [stripe, setStripe] = useState(null);
  const [stripeStatus, setStripeStatus] = useState(null);
  // Estado para Culqi
  const [culqiStatus, setCulqiStatus] = useState(null);

  // Estado de Redux para COD
  const { currentOrder, loading: isCODProcessing, error: codError } = useSelector(state => state.payment);

  //console.log(isCODProcessing);
  // console.log(codError);
  devLog("currentOrder", currentOrder);

  // 1. Manejar flujo Stripe
  useEffect(() => {
    if (paymentMethod !== "stripe") return;

    const initializeStripe = async () => {
      const stripeInstance = await stripePromise;
      setStripe(stripeInstance);
    };

    initializeStripe();
  }, [paymentMethod]);

  // 2. Verificar estado de pago Stripe
  useEffect(() => {
    if (!stripe || paymentMethod !== "stripe") return;

    const verifyStripePayment = async () => {
      const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");

      if (!clientSecret) {
        setStripeStatus("failed");
        return;
      }

      try {
        const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

        if (paymentIntent.status === "succeeded") {
          await api.get(`/order/confirm/${orderId}`);
          localStorage.removeItem("orderId");
          setStripeStatus("succeeded");
        } else {
          setStripeStatus("failed");
        }
      } catch (error) {
        console.error("Stripe error:", error);
        setStripeStatus("failed");
      }
    };

    verifyStripePayment();
  }, [stripe, orderId, paymentMethod]);

  // 3. Verificar estado de pago Culqi
  useEffect(() => {
    if (paymentMethod !== "culqi") return;

    const verifyCulqiPayment = async () => {
      if (!orderId) {
        setCulqiStatus("failed");
        return;
      }

      try {
        await api.get(`/order/confirm/${orderId}`);
        localStorage.removeItem("orderId");
        setCulqiStatus("succeeded");
      } catch (error) {
        console.error("Culqi confirm error:", error);
        setCulqiStatus("failed");
      }
    };

    verifyCulqiPayment();
  }, [paymentMethod, orderId]);

  // 3. Determinar estado actual
  const getPaymentStatus = () => {
    devLog("dentrodegetpaymentstatus", paymentMethod);
    devLog(paymentMethod);
    if (paymentMethod === "stripe") {
      if (!stripeStatus) return "loading";
      return stripeStatus;
    }

    if (paymentMethod === "culqi") {
      if (!culqiStatus) return "loading";
      return culqiStatus;
    }

    if (paymentMethod === "cod" || currentOrder) {
      devLog(currentOrder.confirmed);

      //if (isCODProcessing) return "processing";
      //if (codError) return "failed";
      if (currentOrder?.confirmed) return "succeeded";
      return "loading";
    }

    return "failed"; // Método de pago no reconocido
  };

  const paymentStatus = getPaymentStatus();
  devLog(paymentStatus);
  // Renderizado condicional
  const renderContent = () => {
    switch (paymentStatus) {
      case "succeeded":
        return (
<div className="text-center flex flex-col items-center">
  {/* Icono */}
  <img src={successImage} alt="Success" className="mx-auto w-32 h-32" />

  {/* Título Principal */}
  <h2 className="text-[#ae1d22] text-3xl font-extrabold mt-6 tracking-wide">
    GRACIAS POR COMPRAR EN TEKOS
  </h2>
  
  {/* Subtítulo */}
  <p className="text-[#ae1d22] mt-2 text-xl font-medium">
    Te escribiremos por interno para coordinar tu envío máximo en 48 horas
  </p>

  {/* Botones */}
  <div className="mt-8 flex justify-center gap-4">
    <Link 
      to="/dashboard/my-orders" 
      className="px-6 py-2 bg-[#ae1d22] text-white font-semibold rounded-md hover:bg-[#ae1d22]/90 transition"
    >
      Ver mis pedidos
    </Link>
    <Link 
      to="/" 
      className="px-6 py-2 bg-white text-[#ae1d22] font-semibold border-2 border-[#ae1d22] rounded-md hover:bg-rose-50 transition"
    >
      Seguir comprando
    </Link>
  </div>
</div>
        );

      case "processing":
        return (
          <div className="text-center">
            <FadeLoader color="#36d7b7" />
            <p className="text-blue-500 mt-4">{paymentMethod === "cod" ? "Confirmando tu pedido..." : "Procesando tu pago..."}</p>
          </div>
        );

      case "failed":
        return (
          <div className="text-center">
            <img src={errorImage} alt="Error" className="mx-auto w-32 h-32" />
            <p className="text-red-500 mt-4 text-lg">{paymentMethod === "cod" ? "Error al confirmar el pedido" : "El pago no se pudo procesar"}</p>
            <div className="mt-6 flex justify-center gap-4">
              <Link to="/dashboard/my-orders" className="px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition">
                Volver al panel
              </Link>
              {paymentMethod !== "cod" && (
                <Link to="/pago" className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition">
                  Reintentar pago
                </Link>
              )}
            </div>
          </div>
        );

      default:
        return (
          <div className="text-center">
            <FadeLoader color="#36d7b7" />
            <p className="text-blue-500 mt-4">Cargando información del pago...</p>
          </div>
        );
    }
  };
  
if (isCODProcessing) {
  return <p>Procesando tu pedido, por favor espera...</p>; // <-- Usando isCODProcessing
}

if (codError) {
  return <p>Error al confirmar el pedido: {codError}</p>; // <-- Usando codError
}
  return <div className="min-h-screen flex flex-col justify-center items-center p-4 bg-gray-50">{renderContent()}</div>;
};

export default ConfirmOrder;
